import Enum from '@square/dashboard-utilities/utils/enum';
import CardSummary from '@square/dashboard-data/models/squareup/simple-instrument-store/api/card-summary';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { UnlinkContext } from '@square/dashboard-data/models/squareup/rolodex/instruments-on-file';
import { UsageContext, LinkContext } from '@square/dashboard-data/models/squareup/simple-instrument-store/external-api/query-instrument-request';
export const Type = new Enum(['CARD', 'BANK']);
export default ProtoBaseModel.extend({
  token: attr('string'),
  type: attr('enum', {
    enumClass: Type
  }),
  card: attr('proto-base-model', {
    modelClass: CardSummary,
    embedded: true
  }),
  active: attr('boolean'),
  unlinked_at: attr('number'),
  frozen_at: attr('number'),
  linked_at: attr('number'),
  verified_at: attr('number'),
  metadata: attr('string'),
  usage_context: attr('proto-base-model', {
    modelClass: UsageContext,
    embedded: true
  }),
  link_context: attr('proto-base-model', {
    modelClass: LinkContext,
    embedded: true
  }),
  unlink_context: attr('proto-base-model', {
    modelClass: UnlinkContext,
    embedded: true
  })
});